<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppFilterDateRange
            ref="dateRangeFilter" 
            v-bind:filterDateOverride="onFilterDateOverride"
            v-on:filter-data-change="onFilterDateChange" />
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM_DISPLAY" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-bind:modalShowAdd="modalAllowAdd"
        v-bind:modalShowEdit="modalAllowEdit"
        v-bind:modalShowDelete="false"
        v-on:modal-data-input="onFormInput"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick">
        
        <div
          v-show="validateTinButtonShow"
          slot="jt-form-slot-sectionValidateTin">

          <br>

          <button type="button" class="btn btn-primary" @click="validateTin">Validate</button>

          <TemplateLoading v-show="validateTinLoading" />

          <TemplateAlert 
            v-if="validateTinError"
            v-bind:error="validateTinError" />
        </div>
        
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateAlert from "@/components/Template/TemplateAlert";
import TemplateLoading from "@/components/Template/TemplateLoading";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM_DISPLAY = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'id',
    text: 'E-Bill ID',
    table_popup: true, 
  },
  {
    key: 'Document.uuid',
    text: 'UUID',
    table_popup: true, 
  },
  {
    key: 'eInvoiceNumber',
    text: 'E-Bill No.',
    table_popup: true, 
  },
  {
    key: 'Document.finalTotal',
    text: 'Total Amount (RM)',
  },
  {
    key: 'Document.Constraints_InvoiceType.name',
    text: 'E-Bill Type',
  },
  {
    key: 'Document.invoiceAt',
    text: 'E-Bill Date',
  },
  {
    key: 'Document.createdAt',
    text: 'Sent Date',
  },
  {
    key: 'Document.submissionId',
    text: 'Submission ID',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let dataItem = dataResult[dataIndex];
      return dataItem['Document'] && dataItem['Document']['submissionId'] ? dataItem['Document']['submissionId'] : 'NA'
    },
  },
  // {
  //   key: 'isCancel',
  //   text: 'Cancel',
  //   table_custom: helper.tableCustomYesNo,
  // },
  {
    key: 'Document.status',
    text: 'Status',
  },
];

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'id',
    text: 'E-Bill ID',
  },
  {
    key: 'eInvoiceNumber',
    text: 'E-Bill No.',
    table_popup: true, 
  },
  {
    key: 'Document.uuid',
    text: 'UUID',
    table_popup: true, 
  },
  {
    key: 'supplierId',
    text: 'Supplier ID',
  },
  {
    key: 'Document.Supplier.name',
    text: 'Supplier Name',
  },
  {
    key: 'Document.Supplier.tin',
    text: 'TIN',
  },
  {
    key: 'Document.total1',
    text: 'Unit Price (RM)',
  },
  {
    key: 'Document.total2',
    text: 'SST (RM)',
  },
  {
    key: 'Document.finalTotal',
    text: 'Total Amount (RM)',
  },
  {
    key: 'Document.Constraints_InvoiceType.name',
    text: 'E-Bill Type',
  },
  {
    key: 'Document.invoiceAt',
    text: 'E-Bill Date',
  },
  {
    key: 'Document.createdAt',
    text: 'Sent Date',
  },
  {
    key: 'Document.submissionId',
    text: 'Submission ID',
  },
  // {
  //   key: 'isCancel',
  //   text: 'Cancel',
  // },
  {
    key: 'Document.status',
    text: 'Status',
  },
  {
    key: 'Document.error',
    text: 'Error',
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageEInvoiceDocument",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    TemplateAlert,
    TemplateLoading,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Management' },
        { name: 'E-Invoice Document' },
      ],

      PARAM_DISPLAY,
      PARAM,
      PARAM_MAP,

      showAdd: false,

      supplierToken: '',
      serviceToken: helper.BEE_INVOIS_SERVICE_TOKEN,

      validateTinButtonShow: false,
      validateTinLoading: false,
      validateTinError: '',

      modalAllowAdd: false,
      modalAllowEdit: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.loadSupplierToken();
    
    this.$nextTick(() => {
      this.$refs['dateRangeFilter'].setStartDate(moment().startOf('month'));
      this.$refs['dateRangeFilter'].setEndDate(moment().endOf('month'));
    })
  },
  methods: {
    onFilterDateOverride(component, start, end) {
      let diffInDays = end.diff(start, 'days');
      if(diffInDays > 31) {
        end = new moment(start).add(start.daysInMonth() - 1, 'days').endOf('days')
        component.setEndDate(end)
      }
      component.$emit('filter-data-change', start, end);
    },

    loadSupplierToken() {
      this.$refs['pageFeedback'].setFeedbackLoading('Obtaining supplier token...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/einvoice',
          helper.createAxiosConfig()
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          try {
            this.supplierToken = response.data.result[0].token
          } catch(e) {
          }

          if(window.location.href.includes('localhost')) {
            this.supplierToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdXBwbGllcklkIjoxLCJpYXQiOjE3MjE3MjUyMDJ9.tQzPM0UxzIVXn7Jb46c7RvQDqwRvsRY5EHXJV3jNPEc'
          }

          this.$refs['pageFeedback'].setFeedbackMessage();

          if (!this.supplierToken) {
            this.showAdd = true
            // this.$refs['pageFeedback'].setFeedbackError('Problem obtaining supplier token, please contact system administrator');
            return
          }

          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'supplier token'));
        });
    },
    onFilterDateChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    async loadData() {
      this.showAdd = false

      this.$refs['pageTable'].setTablePaging(true)
      this.$refs['pageTable'].setTableLoading('Loading supplier profile...');

      let url = helper.BEE_INVOIS_URL + '/v1/supplier/e-bill/list'
      url += '?startDate=' + this.$refs['dateRangeFilter'].filterDateStart.unix()
      url += '&endDate=' + this.$refs['dateRangeFilter'].filterDateEnd.unix()
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.supplierToken

      this.$http
        .get(
          url,
          config
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);

          let start = this.$refs['dateRangeFilter'].filterDateStart
          let end = this.$refs['dateRangeFilter'].filterDateEnd

          let list = []
          for (let temp of response.data) {
            // let billDate = moment(temp['invoiceDate'])
            // console.log(billDate.format('YYYY-MM-DD'))

            // if (billDate.unix() < start.unix()) {
            //   continue
            // }

            // if (billDate.unix() > end.unix()) {
            //   continue
            // }

            if (temp['Document']) {
              temp['Document.invoiceAt'] = moment(temp['Document']['invoiceAt']).format('YYYY-MM-DD HH:mm:ss')
              temp['Document.createdAt'] = moment(temp['Document']['createdAt']).format('YYYY-MM-DD HH:mm:ss')
            }

            list.push(temp)
          }

          this.$refs['pageTable'].setTableData(response.data)
        })
        .catch(error => {
          console.log(error)
          this.$refs['pageFeedback'].setFeedbackError('Problem loading supplier profile');
        })
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/passtype/';
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.modalAllowAdd = false
      this.validateTinButtonShow = true
      this.validateTinError = ''

      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add Supplier');
    },
    onTableDataClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      if (tableParameter[tableParameterIndex].key === 'eInvoiceNumber') {
        if (tableData[tableDataIndex] && tableData[tableDataIndex]['Document'] && tableData[tableDataIndex]['Document']['billPdfUrl']) {
          window.open(tableData[tableDataIndex]['Document']['billPdfUrl'], '_blank').focus();
        }
        return
      }

      if (tableParameter[tableParameterIndex].key === 'Document.uuid') {
        if (tableData[tableDataIndex] && tableData[tableDataIndex]['Document'] && tableData[tableDataIndex]['Document']['publicUrl']) {
          window.open(tableData[tableDataIndex]['Document']['publicUrl'], '_blank').focus();
        }
        return
      }

      this.modalAllowEdit = true
      this.validateTinButtonShow = false
      this.validateTinError = ''

      for(let param of PARAM) {
        param['form_hide'] = true
        param['form_input_attr'] = param['form_input_attr'] || {}
        param['form_input_attr']['disabled'] = true
      }

      this.$refs['pageModal'].setModalMessage('Loading consolidated bill detail...');
      this.$refs['pageModal'].setModalOpen(false, tableData[tableDataIndex]['eInvoiceNumber'] + ' Detail', tableData[tableDataIndex]);

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.supplierToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + `/v1/supplier/e-bill/${tableData[tableDataIndex]['id']}/details/`,
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);

          for(let param of PARAM) {
            param['form_hide'] = false
          }

          let temp = response.data.record

          if (temp['Document']) {
            temp['Document.uuid'] = temp['Document']['uuid']

            if (temp['Document']['Supplier']) {
              temp['Document.Supplier.name'] = temp['Document']['Supplier']['name']
              temp['Document.Supplier.tin'] = temp['Document']['Supplier']['tin']
            }

            if (temp['Document']['Constraints_InvoiceType']) {
              temp['Document.Constraints_InvoiceType.name'] = temp['Document']['Constraints_InvoiceType']['name']
            }

            temp['Document.total1'] = temp['Document']['total1']
            temp['Document.total2'] = temp['Document']['total2']
            temp['Document.finalTotal'] = temp['Document']['finalTotal']

            temp['Document.invoiceAt'] = moment(temp['Document']['invoiceAt']).format('YYYY-MM-DD HH:mm:ss')
            temp['Document.createdAt'] = moment(temp['Document']['createdAt']).format('YYYY-MM-DD HH:mm:ss')
            temp['Document.submissionId'] = temp['Document']['submissionId']
            temp['isCancel'] = temp['isCancel'] ? 'YES' : 'NO'
            temp['Document.status'] = temp['Document']['status']
            temp['Document.error'] = temp['Document']['error'] || 'NA'
          }

          this.$refs['pageModal'].setModalMessage();

          this.$refs['pageModal'].setModalOpen(false, tableData[tableDataIndex]['eInvoiceNumber'] + ' Detail', temp);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError('Problem loading consolidated bill detail');
        });
    },

    async onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding supplier ' + selectedData.name);

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      selectedData['identifier'] = {
        type: selectedData['identifierTypeId'],
        value: selectedData['identifierValue'],
      }

      selectedData['msicId'] = parseInt(selectedData['msicId'])
      selectedData['stateId'] = parseInt(selectedData['stateId'])
      selectedData['countryId'] = parseInt(selectedData['countryId'])
      selectedData['status'] = selectedData['status'] ? 1 : 0

      let startDate = helper.parseDateTime(selectedData['startDate']).startOf('day').unix()
      delete selectedData['startDate']

      let result = await this.$http
        .post(
          helper.BEE_INVOIS_URL + '/v1/main/supplier/add',
          selectedData,
          config,
        )
        .then(response => {
          return response.data
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError('Problem adding supplier');
        })

      if (!result || !result.record || !result.record.id || !result.record.hashToken) {
        return
      }

      this.$http
        .post(
          helper.SERVER_URL + '/api2/einvoice',
          querystring.stringify({
            supplierID: result.record.id,
            token: result.record.hashToken,
            status: selectedData.status,
            operatorID: localStorage.getItem('selectedOperatorID'),
            startDate: startDate,
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.supplierToken = result.record.hashToken
          this.upsertDataComplete('Successfully added supplier ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'supplier'));
        })
    },
    async onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating supplier ' + selectedData.name);

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.supplierToken

      selectedData['identifier'] = {
        type: selectedData['identifierTypeId'],
        value: selectedData['identifierValue'],
      }

      selectedData['msicId'] = parseInt(selectedData['msicId'])
      selectedData['stateId'] = parseInt(selectedData['stateId'])
      selectedData['countryId'] = parseInt(selectedData['countryId'])
      selectedData['status'] = selectedData['status'] ? 1 : 0

      let result = await this.$http
        .put(
          helper.BEE_INVOIS_URL + `/v1/main/supplier/${selectedData['id']}/edit`,
          selectedData,
          config,
        )
        .then(response => {
          return response.data
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError('Problem updating supplier');
        })

      if (!result || !result.record || !result.record.id || !result.record.hashToken) {
        return
      }

      this.$http
        .post(
          helper.SERVER_URL + '/api2/einvoice',
          querystring.stringify({
            supplierID: result.record.id,
            token: result.record.hashToken,
            status: selectedData.status,
            operatorID: localStorage.getItem('selectedOperatorID'),
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update supplier ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'supplier'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'identifierTypeId' || formParameter.key === 'identifierValue' || formParameter.key === 'tin') {
        this.validateTinButtonShow = true
        this.modalAllowAdd = false
        this.modalAllowEdit = false

        for(let param of PARAM) {
          param['form_input_attr'] = param['form_input_attr'] || {}
          param['form_input_attr']['disabled'] = true
        }

        delete PARAM_MAP['identifierTypeId']['form_input_attr']
        delete PARAM_MAP['identifierValue']['form_input_attr']
        delete PARAM_MAP['tin']['form_input_attr']
        this.$forceUpdate()
      } else if(formParameter.key === 'city') {
        this.onFormCityChange();
      } else if(formParameter.key === 'NoSST') {
        formData['ExemptSST'] = 0;
        formData['ExclusiveSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'ExclusiveSST') {
        formData['NoSST'] = 0;
        formData['ExemptSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      }
    },
    onFormCityChange() {
        let formData = this.$refs['pageModal'].$refs['modalForm'].formData;
        formData['stateId'] = null;
        formData['countryId'] = null;
        
        let selectedCity = helper.inputSelectFindOption(PARAM_MAP['city'], formData['city']);
        if(!selectedCity) {
          return this.$refs['pageForm'].$forceUpdate();
        }

        let selectedState = helper.inputSelectFindOption(PARAM_MAP['stateId'], selectedCity.stateID);
        if(!selectedState) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['stateId'] = selectedState.id;

        // TODO kw1 map state to country
        let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['countryId'], selectedState.countryID);
        if(!selectedCountry) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['countryId'] = selectedCountry.id;
        return this.$refs['pageModal'].$refs['modalForm'].$forceUpdate();
    },

    validateTin() {
      this.validateTinLoading = true
      this.validateTinError = ''

      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;

      // this.$refs['pageModal'].setModalLoading('Validating TIN');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + `/v1/main/invois/e-invoice/taxpayer/validate/${formData['tin']}?idType=${formData['identifierTypeId']}&idValue=${formData['identifierValue']}`,
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);

          response = response || {}
          response.data = response.data || {}

          if (response.data.record === true) {
            this.$refs['pageModal'].setModalMessage('')
            for(let param of PARAM) {
              param['form_hide'] = false
              param['form_input_attr'] = param['form_input_attr'] || {}
              param['form_input_attr']['disabled'] = false
            }

            if(this.$refs['pageModal'].$refs['modalForm'].formIsAdd) {
              PARAM_MAP['createdAt']['form_hide'] = true
              PARAM_MAP['updatedAt']['form_hide'] = true
            }

            this.modalAllowAdd = true
            this.modalAllowEdit = true

            this.$forceUpdate()
          } else if (response.data.record === false) {
            this.validateTinError = 'Invalid TIN, please try again'
          } else {
            this.validateTinError = 'Problem validating TIN, please try again'
          }
        })
        .catch(error => {
          // this.$refs['pageModal'].setModalError('Problem validating TIN, please try again');
          this.validateTinError = 'Problem validating TIN, please try again'
        })
        .finally(() => {
          this.validateTinLoading = false
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/BillManagement/PageEInvoiceDocument.vue